'use strict';

import {Tabs} from "../components/ui/Tabs";
import useModalProps from "../hooks/useModalProps";

const TABS = {
    CLASSES: 'classes',
    AIRCRAFT: 'aircraft',
}

function BarometerModal(props) {
    
    const {tab} = useModalProps('reactBarometerModal', props, {tab: TABS.CLASSES})

    // Местное
    const [ data, setData ] = React.useState({ routes: [], classes: {}, aircraft: null });
    const [ activeTab, setActiveTab ] = React.useState(tab || TABS.CLASSES);
    const [ activeClass, setActiveClass ] = React.useState(null);
    
    const { classesData, classesLabels, classesMonthIndex, classesCurrencySymbol } = React.useMemo(() => {
        if (data.classes && Array.isArray(data.classes.items)) {
            const { itemsData, itemsLabels, monthIndex } = getPreparedData(data.classes.items)
            
            return { 
                classesData: itemsData,
                classesLabels: itemsLabels,
                classesMonthIndex: monthIndex,
                classesCurrencySymbol: data.classes.currency?.symbol || '',
            }
        }

        return {
            classesData: [],
            classesLabels: [],
            classesMonthIndex: 0,
            classesCurrencySymbol: '',
        }
    }, [ data.classes?.items ])
    const { aircraftTitle, aircraftData, aircraftLabels, aircraftMonthIndex, aircraftCurrencySymbol } = React.useMemo(() => {
        if (data.aircraft) {
            const { itemData, monthLabels, monthIndex } = getPreparedDataItem(data.aircraft)
            
            return {
                aircraftTitle: itemData.title,
                aircraftData: itemData,
                aircraftLabels: monthLabels,
                aircraftMonthIndex: monthIndex,
                aircraftCurrencySymbol: data.aircraft.currency?.symbol,
            }
        }
        
        return {
            aircraftTitle: '',
            aircraftData: null,
            aircraftLabels: [],
            aircraftMonthIndex: 0,
            aircraftCurrencySymbol: '',
            
        }
    }, [ data.aircraft ])
    
    const routes = data.routes
    const filteredClassesData = React.useMemo(() => classesData.filter(c => Number(c.average_price) > 0), [classesData])

    const activeClassData = filteredClassesData.find(e => e.id === activeClass)
    
    const activeClassAveragePrice = React.useMemo(() => {
        let price;
        switch (activeTab) {
            case TABS.AIRCRAFT: price = aircraftData?.average_price; break;
            case TABS.CLASSES: price = activeClassData?.average_price; break;
            default: price = 0;
        }
        return new Intl.NumberFormat('ru-RU').format(price || 0)
    }, [ activeTab, aircraftData?.average_price, activeClassData?.average_price ])

    const chartData = (function () {
        let prices = [], labels = [], index = 0, currency = undefined

        if (activeTab === TABS.CLASSES) {
            prices = activeClassData?.prices || []
            labels = classesLabels
            index = classesMonthIndex
            currency = classesCurrencySymbol
        }
        if (activeTab === TABS.AIRCRAFT) {
            prices = aircraftData?.prices || []
            labels = aircraftLabels
            index = aircraftMonthIndex
            currency = aircraftCurrencySymbol
        }

        return { prices, labels, index, currency }
    })()
    
    React.useEffect(() => {
        listenEvent('react.openBarometer', (data) => setData(data))
    }, [])

    React.useEffect(() => {
        if (tab) {
            setActiveTab(tab);
        }
    }, [ tab ])

    React.useEffect(() => {
        if (!aircraftData) {
            setActiveClass(null)
        }
    }, [ aircraftData ])
    
    React.useEffect(() => {
        switch ( activeTab ) {
            case TABS.CLASSES:
                if (filteredClassesData.length > 0) {
                    if (activeClass === null) {
                        setActiveClass(filteredClassesData[0].id)
                    }
                }
                break;
            case TABS.AIRCRAFT:
                if (aircraftData) {
                    setActiveClass(aircraftData.class_id)
                }
                break;
        }
    }, [ activeTab, activeClass, filteredClassesData, aircraftData ] )
    
    
    function getPreparedData (barometerItems = []) {
        
        const itemsData = [];
        let itemsLabels = [];
        let activeClass = null;
        let monthIndex = 0;

        barometerItems
            .sort((a, b) => parseInt(a.sort) - parseInt(b.sort))
            .map((item, index) => {
                const {itemData, monthLabels, monthIndex: itemMonthIndex} = getPreparedDataItem(item)
                itemsData.push(itemData)
                if (index === 0) {
                    monthIndex = itemMonthIndex
                    itemsLabels = monthLabels
                    activeClass = item.id
                }
            });
        
        return {itemsData, itemsLabels, activeClass, monthIndex}
    }
    
    function getPreparedDataItem (barometerItem = {}) {
        
        const monthLabels = [];
        let monthIndex = 0;
        const months = barometerItem.months
        const currentYear = moment().format('YYYY')
        
        const itemData = {
            id: barometerItem.id || barometerItem.aircraft?.id,
            class_id: barometerItem.aircraft?.class_id || barometerItem.id,
            title: barometerItem.title || barometerItem.aircraft?.title,
            average_price: parseInt(barometerItem.average_price),
            prices: months.map((month) => parseInt(month.price))
        }
        months.map((month, month_index) => {
            let title = moment(month.month, 'YYYY-MM').format('MMM' + (currentYear !== moment(month.month, 'YYYY-MM').format('YYYY') ? ' YYYY' : '')).replace(/\./g, "");
            title = title.length > 1 ? title[0].toUpperCase() + title.slice(1) : '';
            monthLabels.push(title)
            if (month.is_current) 
                monthIndex = month_index
        });
        
        return {itemData, monthLabels, monthIndex}
    }
    
    return <React.Fragment>

        <div className="graph-modal__top">

            {activeTab === TABS.AIRCRAFT && <h3 className="graph-modal__title">
                {aircraftTitle}
            </h3>}

            {filteredClassesData.length > 0 && <div className="plane_compare-tabs tabs-primary">
                <ul className="plane_compare-tabs-list">
                    {activeTab === TABS.CLASSES && filteredClassesData.map(({id, title}) => {
                        return <li key={`barometerClasses${id}`}>
                            <a role='button' className={cn(activeClass === id && 'active')} onClick={() => setActiveClass(id)}>
                                {title}
                            </a>
                        </li>
                    })}
                </ul>
            </div>}

            <div className="graph-modal__links">
                {activeTab === TABS.AIRCRAFT && <a role="button" className="graph-modal__class" onClick={() => setActiveTab(TABS.CLASSES)}>{tMsg('График цен по классам')}</a>}
                {activeTab === TABS.CLASSES && <a role="button" className="graph-modal__class" onClick={() => setActiveTab(TABS.AIRCRAFT)}>{aircraftTitle}</a>}
                <a type='button' className="graph-modal__close" data-fancybox-close>{tMsg('Закрыть')}</a>
            </div>
        </div>

        {/* !!! ТУТ ВЕСЬ ГРАФИК !!! */}
        <ChartCanvas data={chartData} />

        <div className="graph-modal__bottom">
            <div className="graph-modal__dir">
                {routes.map(({title, icao}, index) => {
                    return <React.Fragment key={`barometerRoutes${index}`}>
                        <div key={`routeBarometer${index}`}>
                            {title} <span>{icao}</span>
                        </div>
                        {index !== routes.length - 1 && <i className="icon-plane4"></i>}
                    </React.Fragment>
                })}
            </div>
            <div className="graph-modal__average">
                {__('barometer.averagePriceFor{n}Months', { '{n}': classesLabels.length || 0 })}
                <span>{`${activeClassAveragePrice} ${classesCurrencySymbol || aircraftCurrencySymbol}`}</span>
            </div>
        </div>
    </React.Fragment>
}

function ChartCanvas({ data = {} }) {
    
    const canvasRef = React.useRef()
    const [isCanvasReady, setIsCanvasReady] = React.useState(false);
    
    const [chartAircraft, setChartAircraft] = React.useState(null);

    const {prices, labels, index, currency} = data;
    const extendedLabels = ['', ...labels, ''];

    React.useEffect(() => {
        if (!isCanvasReady)
            setTimeout(() => setIsCanvasReady(true), 300);
    }, [])
    
    React.useEffect(() => {
        initAircraftChart()

        return () => {
            if (chartAircraft) {
                chartAircraft.destroy()
                setChartAircraft(null)
            }
        }
    }, [])

    React.useEffect(() => {
        updateAircraftLabels()
    }, [labels])

    React.useEffect(() => {
        updateAircraftChart()
    }, [prices])

    React.useEffect(() => {
        updateAircraftChartOptions()
    }, [currency, index])


    // RINAT

    function normalizeData ( data ) {
        return data.map ( v => v === 0 ? null : v );
    }

    function getMinMax ( data ) {
        const filtered = data.filter( v => v !== null );
        return {
            min: filtered.length > 1 ? Math.min( ...filtered ) : 0,
            max: Math.max( ...filtered ),
        };
    }

    function extendLine(data) {
        const first = data.find(v => v !== null);
        const last = [...data].reverse().find(v => v !== null);

        return [first, ...data, last];
    }
    
    const fullGradientPlugin = {
        id: 'fullGradient',
        beforeDatasetsDraw(chart) {
            const {ctx, chartArea} = chart;
            if (!chartArea) return;

            const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
            gradient.addColorStop(0, 'rgba(255,0,0,0.1)');
            gradient.addColorStop(1, 'rgba(255,0,0,0)');
            chart.data.datasets.forEach(ds => {
                ds.backgroundColor = gradient;
                ds.fill = 'start';
            });
        }
    };

    const currentMonthLine = {
        id: 'currentMonthLine',
        afterDatasetsDraw(chart) {
            const {ctx, chartArea: {bottom}, scales: {x}, data} = chart;
            const { index = 0 } = data;
            const meta = chart.getDatasetMeta(0);
            const point = meta.data[index + 1];
            if (!point) return;

            const xPos = x.getPixelForTick(index + 1);
            const yPos = point.y;

            ctx.save();
            ctx.beginPath();
            ctx.setLineDash([5, 6]);
            ctx.moveTo(xPos, bottom);
            ctx.lineTo(xPos, yPos);
            ctx.lineWidth = 1;
            ctx.strokeStyle = '#ff0000';
            ctx.stroke();
            ctx.restore();
        }
    };

    const chartOptions = (min, max, padding) => ({
        responsive: true,
        maintainAspectRatio: false,
        animation: {duration: 300},
        interaction: {
            mode: 'index',
            intersect: true
        },
        onHover: (event, elements, chart) => {
            chart.setActiveElements(
                elements.filter(el => {
                    const i = el.index;
                    return i !== 0 && i !== chart.data.datasets[0].data.length - 1;
                })
            );
        },
        plugins: {
            legend: {display: false},
            tooltip: {enabled: false},
            datalabels: {
                align: 'top',
                anchor: 'end',
                color: '#000',
                font: {size: 14, weight: '400', family: 'Cera Pro'},
                formatter: (v, ctx) => {
                    if (
                        ctx.dataIndex === 0 ||
                        ctx.dataIndex === ctx.dataset.data.length - 1 ||
                        v === null
                    ) return '';
                    return v.toLocaleString() + ` ${currency}`;
                },
            }
        },
        scales: {
            x: {
                offset: false,
                grid: {display: false},
                ticks: {
                    callback: (val, index) => {
                        return index === 0 || index === extendedLabels.length - 1 ? '' : labels[index - 1];
                    },
                    color: ctx => ctx.index === index + 1 ? '#ff0000' : '#999',
                    font: {size: 12}
                }
            },
            y: {
                display: false,
                min: min - padding,
                max: max + padding
            }
        }
    });

    function initAircraftChart() {
        if (!canvasRef.current || chartAircraft) {
            return
        }
        
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');

        const rawData = normalizeData(prices);
        const data = extendLine(rawData);
        const { min, max } = getMinMax(rawData);
        
        const padding = (max - min) * 0.5;

        const newChartAircraft = new Chart(ctx, {
            type: 'line',
            data: {
                labels: extendedLabels,
                datasets: [{
                    data: data,
                    borderColor: '#ff0000',
                    borderWidth: 1,
                    pointBackgroundColor: '#fff',
                    pointBorderColor: '#ff0000',
                    spanGaps: true,
                    segment: {
                        pointStyle: ctx => {
                            if (ctx.p0DataIndex === 0 || ctx.p0DataIndex === ctx.chart.data.datasets[0].data.length - 1) {
                                return false;
                            }
                        }
                    }
                }]
            },
            options: chartOptions(min, max, padding),
            plugins: [ChartDataLabels, fullGradientPlugin, currentMonthLine]
        })
        
        setChartAircraft(newChartAircraft);

        requestAnimationFrame(() => {
            newChartAircraft.update();
        })
    }

    function updateAircraftChart() {
        if (!chartAircraft) return;
        
        const rawData = normalizeData(prices);
        const data = extendLine(rawData);
        const { min, max } = getMinMax(rawData);
        
        const padding = (max - min) * 0.5;

        chartAircraft.data.datasets[0].data = data;
        chartAircraft.options.scales.y.min = min - padding;
        chartAircraft.options.scales.y.max = max + padding;
        
        chartAircraft.update();
    }

    function updateAircraftLabels() {
        if (!chartAircraft) return;
        
        chartAircraft.data.labels = extendedLabels;
        chartAircraft.update();
    }

    function updateAircraftChartOptions() {
        if (!chartAircraft) return;

        const rawData = normalizeData(prices);
        const { min, max } = getMinMax(rawData);

        const padding = (max - min) * 0.5;

        chartAircraft.data.index = index;
        chartAircraft.options = chartOptions(min, max, padding)
        chartAircraft.data.labels = extendedLabels;
        chartAircraft.update();
    }
    // END RINAT
    
    
    return (
        <div className={cn('chart-container', isCanvasReady && 'active')}>
            <div className="chart-wrapp">
                {<canvas ref={canvasRef}></canvas>}
            </div>
        </div>
    )
}

const domContainer = document.querySelector('#reactBarometerModal');
const root = ReactDOM.createRoot(domContainer);
root.render(React.createElement(BarometerModal));
